export default "<md-content ui-view=\"app\" layout=\"column\" flex></ui-view>\n";